import React, { FC } from 'react';

import { Field, FilterTypes, ValueBasedFilterTypes } from '../types';
import { getFilterLabels } from '../utils';
import css from './FilterSentence.module.scss';

interface FilterSentenceProps {
  filter: FilterTypes;
  fields: Field[];
  onEditField: (filter: FilterTypes) => void;
  onEditOperator: (filter: FilterTypes) => void;
  onEditValue: (filter: FilterTypes) => void;
}

export const FilterSentence: FC<
  React.PropsWithChildren<FilterSentenceProps>
> = ({ filter, fields, onEditField, onEditOperator, onEditValue }) => {
  const { fieldLabel, operatorLabel, valueLabel } = getFilterLabels(
    filter as ValueBasedFilterTypes,
    fields
  );

  return (
    <div className={css.container}>
      <div
        className={css.field}
        onClick={() => onEditField(filter)}
        role='button'
        tabIndex={-1}
        title='Change Field'
      >
        {fieldLabel}
      </div>
      <div
        className={css.operator}
        onClick={() => onEditOperator(filter)}
        role='button'
        tabIndex={-1}
        title='Update Operator'
      >
        {operatorLabel}
      </div>
      <div
        className={css.value}
        onClick={() => onEditValue(filter)}
        role='button'
        tabIndex={-1}
        title='Update Value'
      >
        {valueLabel}
      </div>
    </div>
  );
};
